const aepsColors = {
  PRIMARY: '#DF9F38',
  BRAND_COLOR_GRAY_2: '#A0A0A0',
  PRIMARY_ULTRA_LIGHT: '#F8EBD7',
  ERROR: '#C94949',
  DISMANTLED_GREEN: '#4BA34529',
  GRAY_75: '#757575',
  DISABLED_GREY: '#A0A0A0',
  BRAND_COLOR_GRAY_1: '#a6a6a6',
  SECONDARY_GREY: '#a6a6a6',
  BLACK_75: '#212121',
  BG_SECONDARY_BUTTON_HOVER: '#FFF',
  TRANSPARENT_SHADE: '#00000040',
  PRIMARY_STORNG: '#6E461B',
  BRAND_PRIMARY_RED: '#CA4327',
  BG_PRIMARY_BUTTON_CLICKED: '#F2BE75',
  BG_PRIMARY_BUTTON_HOVER: '#F2BE75',
  BRAND_PRIMARY_ACTION: '#DF9F38',
  PRIMARY_LIGHT: '#F2BE75',
}

const refundColors = {
  PRIMARY: '#DF9F38',
  BRAND_COLOR_GRAY_2: '#A3A3A3',
  PRIMARY_ULTRA_LIGHT: '#F8EBD7',
  ERROR: '#C94949',
  DISMANTLED_GREEN: '#4BA34529',
  GRAY_75: '#757575',
  DISABLED_GREY: '#A0A0A0',
  BRAND_COLOR_GRAY_1: '#2e2e2e',
  SECONDARY_GREY: '#a6a6a6',
  BLACK_75: '#212121',
  BG_SECONDARY_BUTTON_HOVER: '#FFF',
  TRANSPARENT_SHADE: '#00000040',
  PRIMARY_STORNG: '#6E461B',
  BRAND_PRIMARY_RED: '#CA4327',
  BG_PRIMARY_BUTTON_CLICKED: '#F2BE75',
  BG_PRIMARY_BUTTON_HOVER: '#F2BE75',
  BRAND_PRIMARY_ACTION: '#DF9F38',
  PRIMARY_LIGHT: '#F2BE75',
}

export const aepsTheme = {
  colors: aepsColors,
}

export const refundTheme = {
  colors: refundColors,
}
